import '../scss/app.scss';
import '../../css/featherlight.min.css';
import '../../css/featherlight.gallery.min.css';

const $ = jQuery;

$(document).ready(function() {
	// Initialize FitVids
	$('iframe[src*="youtube"],iframe[src*="youtu.be"],iframe[src*="vimeo"]').parent().fitVids({ maxWidth: 1024 });

	// Initialize galleries
	$('.gallery-list').each(function() {
		$(this).find('.gallery-item a').featherlightGallery({
			previousIcon: '<i class="fal fa-angle-left"></i>',
			nextIcon: '<i class="fal fa-angle-right"></i>',
		});
	});
});

// Sliding panel
$(document).ready(function() {
  $('.sliding-panel-button,.sliding-panel-fade-screen,.sliding-panel-close').on('click touchstart',function (e) {
    $('.sliding-panel-content,.sliding-panel-fade-screen').toggleClass('is-visible');
    e.preventDefault();
  });

  $('.sliding-panel-content li.menu-item-has-children > a').click(function (e) {
	e.preventDefault();
	if ($(this).hasClass('open')) {
		$(this).removeClass('open');
		$(this).parent().find('.sub-menu').removeClass('open');
	} else {
		$(this).addClass('open');
		$(this).parent().find('.sub-menu').addClass('open');
    }
  });
});

$.fn.randomize = function(selector) {
	var $elems = selector ? $(this).find(selector) : $(this).children(),
		$parents = $elems.parent();

	$parents.each(function() {
		$(this).children(selector).sort(function() {
			return Math.round(Math.random()) - 0.5;
		}).detach().appendTo(this);
	});

	return this;
};

$('.full-page-image-content').find('.featured-slider').randomize('.slide-wrapper');

$('.social .search a').click(function(e) {
	e.preventDefault();
	const el = $('.top-search-form-container');
	if (el.hasClass('open')) {
		el.removeClass('open');
		el.slideUp(200);
	} else {
		el.addClass('open');
		el.slideDown(200, () => {
			$('.top-search-form-container input.search-field:first').focus();
		});
	}
});

// Featured Slider
$(document).ready(function() {
	$('.featured-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 8000,
        pauseOnHover: true,
	});
});

$(document).ready(function() {
	$('.quotes-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
	});
});



// WEBPACK FOOTER //
// ./src/js/app.js